<template>
  <div id="RankingList">
    <div class="tabs-content">
      <div class="ranking-left">
        <ul>
          <li
            v-for="(item, index) in 10"
            :key="String(index)"
            v-text="index + 1"
          ></li>
        </ul>
      </div>
      <div class="ranking-right">
        <div
          class="ranking-list"
          v-for="(item, index) in data"
          :key="String(index)"
        >
          <a target="_blank" :href="item.url">{{ item.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RankingList",
  props: {
    data: Array
  }
};
</script>
<style scope lang="scss">
#RankingList {
  .tabs-content {
    display: flex;
    justify-content: flex-start;
    .ranking-left {
      ul {
        width: 16px;
        height: 303px;
        background-image: linear-gradient(180deg, #95e8b6 0%, #c0f4c6 100%),
          linear-gradient(#2481fa, #2481fa);
        background-blend-mode: normal, normal;
        border-radius: 8px;
        li {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
        }
      }
    }
    .ranking-right {
      width: 150px;
      margin-left: 15px;
      .ranking-list {
        widows: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        a {
          font-size: 12px;
          line-height: 30px;
          letter-spacing: 1px;
          color: #666666;
        }
        a:hover {
          color: #009944;
        }
      }
    }
  }
}
</style>
